import { Injectable } from '@angular/core'
import { $app } from '../../app.service'

@Injectable({
   providedIn: 'root'
})
export class AppThemeService {
   private themeMap: Map<number | undefined, string> = new Map<number | undefined, string>().set(undefined, 'default').set(4521, 'test')

   public retriveProjectTheme() {
      this.cleanTheme()
      const projectId = $app.getCurrentProjectId()
      document.documentElement.classList.add('theme-' + (this.themeMap.get(projectId) ?? 'default'))
   }

   private cleanTheme() {
      const themeClasses = Array.from(document.documentElement.classList).filter((c) => c.startsWith('theme-'))
      themeClasses.forEach((c) => document.documentElement.classList.remove(c))
   }
}
